import type { Activity, Project, ProjectTemplate } from '../types/portal'

export const brand = {
  mark: 'https://cdn.magicpatterns.com/uploads/rQRCXKM9ag87VfCoqVbHFY/PORPRO_4_copy.svg',
  lockup: 'https://cdn.magicpatterns.com/uploads/7yq9118sRb1S7YhVXb2Giu/PORPRO_1.svg',
}

export const stills = {
  studio:
    'https://cdn.magicpatterns.com/patterns/generated-images/708c105d-c0cd-4ff4-bc5c-d46178787b3d.jpg',
  /** Client access: nothing but light falling across a matte black wall. */
  threshold:
    'https://cdn.magicpatterns.com/patterns/generated-images/4169136d-f91c-444e-821c-f78c8217a313.jpg',
}

/**
 * No seeded clients, projects, deliverables, viewers or activity.
 *
 * Supabase is the source of truth: projects and their deliverables are loaded
 * from the database, and change requests and approvals come from their own
 * tables. Every section falls back to an empty state rather than demo content.
 */
export const projects: Project[] = []

export const activity: Activity[] = []

/**
 * Starting structures only — no client information. These are Portal's own
 * production shapes, used when creating a project.
 */
export const templates: ProjectTemplate[] = [
  {
    id: 'tpl-podcast',
    name: 'Filmed Podcast',
    projectType: 'Filmed Podcast Series',
    deliverables: [
      { name: 'Episode 01', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: true },
      { name: 'Episode 02', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: false },
      { name: 'Audio Master', type: 'Audio', quantity: '1', status: 'Not Started', visibleToClient: false },
      { name: 'Social Cutdowns', type: 'Video', quantity: '8', status: 'Not Started', visibleToClient: false },
      { name: 'Photography', type: 'Photography', quantity: '20', status: 'Not Started', visibleToClient: false },
    ],
  },
  {
    id: 'tpl-event',
    name: 'Event Coverage',
    projectType: 'Event Coverage',
    deliverables: [
      { name: 'Event Highlights Film', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: true },
      { name: 'Speaker Interviews', type: 'Video', quantity: '4', status: 'Not Started', visibleToClient: false },
      { name: 'Social Cutdowns', type: 'Video', quantity: '6', status: 'Not Started', visibleToClient: false },
      { name: 'Photography', type: 'Photography', quantity: '80', status: 'Not Started', visibleToClient: false },
    ],
  },
  {
    id: 'tpl-series',
    name: 'Video Series',
    projectType: 'Video Series',
    deliverables: [
      { name: 'Film 01', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: true },
      { name: 'Film 02', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: false },
      { name: 'Raw Footage', type: 'Folder', quantity: '', status: 'Not Started', visibleToClient: false },
    ],
  },
  {
    id: 'tpl-profile',
    name: 'Profile Film',
    projectType: 'Profile Film',
    deliverables: [
      { name: 'Profile Film', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: true },
      { name: 'Behind the Scenes', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: false },
      { name: 'Photography', type: 'Photography', quantity: '30', status: 'Not Started', visibleToClient: false },
    ],
  },
  {
    id: 'tpl-livestream',
    name: 'Livestream',
    projectType: 'Livestream Production',
    deliverables: [
      { name: 'Livestream Recording', type: 'Video', quantity: '1', status: 'Not Started', visibleToClient: true },
      { name: 'Session Cutdowns', type: 'Video', quantity: '6', status: 'Not Started', visibleToClient: false },
      { name: 'Transcript', type: 'Document', quantity: '1', status: 'Not Started', visibleToClient: false },
    ],
  },
]
